import { Controller } from "@hotwired/stimulus"
import { getScrollbarWidth } from "../utils"

// Connects to data-controller="drawer"
export default class extends Controller {
    static targets = ["trigger"]

    connect() {
        this.#isOpen && this.#setDrawerEndOffset()

        window.addEventListener("resize", this.#onWindowResize)
    }

    disconnect() {
        window.removeEventListener("resize", this.#onWindowResize)
    }

    triggerTargetConnected(/** @type {HTMLElement} */element) {
        element.addEventListener("click", this.#onTriggerClick)
    }

    triggerTargetDisconnected(/** @type {HTMLElement} */element) {
        element.removeEventListener("click", this.#onTriggerClick)
    }

    toggle() {
        this.#isOpen ? this.#close() : this.#open()
    }

    #onWindowResize = () => {
        this.#isOpen && this.#setDrawerEndOffset()
    }

    #onTriggerClick = () => this.toggle()

    #open() {
        this.element.classList.add("tyb-drawer--open")
        this.dispatch("open")
        this.#setDrawerEndOffset()
    }

    #close() {
        this.element.classList.remove("tyb-drawer--open")
        this.dispatch("close")
        this.#removeDrawerEndOffset()
    }

    get #isOpen() {
        return this.element.classList.contains("tyb-drawer--open")
    }

    #setDrawerEndOffset = (offset = getScrollbarWidth()) => {
        document.documentElement
            .style.setProperty("--drawer-end-offset", `${offset}px`)
    }

    #removeDrawerEndOffset = () => {
        document.documentElement.style.removeProperty("--drawer-end-offset")
    }
}
